<template>
  <div class="home-page">
    <el-card>
       <div class="flex-style">
          <span>商户名称：</span>
          <el-select
            v-model="merchantId"
            style="margin-left: 10px;"
            placeholder="请选择"
            @change="getData(),getOrderStoreStat(),getOrderServiceStat()"
          >
            <el-option
              v-for="item in merchantList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
    </el-card>

    <div class="space-between mt20">
      <el-card v-if="statisInfo&&statisInfo.todayData" style="width:18%;padding:16px 20px">
        <p style="font-weight:550">今日</p>
        <div class="space-between">
          <div>
            <p>{{statisInfo.todayData.totalOrderCount}}单</p>
            <p>总订单量</p>
            <p>{{statisInfo.todayData.totalAmount}}元</p>
            <p>成交金额</p>
          </div>
          <div>
            <p>{{statisInfo.todayData.completedOrderCount}}单</p>
            <p>已成交订单</p>
            <p>{{(statisInfo.todayData.conversionRate * 100).toFixed(1)}}%</p>
            <p>转化率</p>
          </div>
        </div>
      </el-card>
      <el-card v-if="statisInfo&&statisInfo.yesterDayData" style="width:18%;padding:16px 20px">
        <p style="font-weight:550">昨日</p>
        <div class="space-between">
          <div>
            <p>{{statisInfo.yesterDayData.totalOrderCount}}单</p>
            <p>总订单量</p>
            <p>{{statisInfo.yesterDayData.totalAmount}}元</p>
            <p>成交金额</p>
          </div>
          <div>
            <p>{{statisInfo.yesterDayData.completedOrderCount}}单</p>
            <p>已成交订单</p>
            <p>{{(statisInfo.yesterDayData.conversionRate * 100).toFixed(1)}}%</p>
            <p>转化率</p>
          </div>
        </div>
      </el-card>
      <el-card v-if="statisInfo&&statisInfo.weekData" style="width:18%;padding:16px 20px">
        <p style="font-weight:550">本周</p>
        <div class="space-between">
          <div>
            <p>{{statisInfo.weekData.totalOrderCount}}单</p>
            <p>总订单量</p>
            <p>{{statisInfo.weekData.totalAmount}}元</p>
            <p>成交金额</p>
          </div>
          <div>
            <p>{{statisInfo.weekData.completedOrderCount}}单</p>
            <p>已成交订单</p>
            <p>{{(statisInfo.weekData.conversionRate * 100).toFixed(1)}}%</p>
            <p>转化率</p>
          </div>
        </div>
      </el-card>
      <el-card v-if="statisInfo&&statisInfo.monthData" style="width:18%;padding:16px 20px">
        <p style="font-weight:550">本月</p>
        <div class="space-between">
          <div>
            <p>{{statisInfo.monthData.totalOrderCount}}单</p>
            <p>总订单量</p>
            <p>{{statisInfo.monthData.totalAmount}}元</p>
            <p>成交金额</p>
          </div>
          <div>
            <p>{{statisInfo.monthData.completedOrderCount}}单</p>
            <p>已成交订单</p>
            <p>{{(statisInfo.monthData.conversionRate * 100).toFixed(1)}}%</p>
            <p>转化率</p>
          </div>
        </div>
      </el-card>
      <el-card v-if="statisInfo&&statisInfo.lastMonthData" style="width:18%;padding:16px 20px">
        <p style="font-weight:550">上月</p>
        <div class="space-between">
          <div>
            <p>{{statisInfo.lastMonthData.totalOrderCount}}单</p>
            <p>总订单量</p>
            <p>{{statisInfo.lastMonthData.totalAmount}}元</p>
            <p>成交金额</p>
          </div>
          <div>
            <p>{{statisInfo.lastMonthData.completedOrderCount}}单</p>
            <p>已成交订单</p>
            <p>{{(statisInfo.lastMonthData.conversionRate * 100).toFixed(1)}}%</p>
            <p>转化率</p>
          </div>
        </div>
      </el-card>
    </div>

    <div class="flex-style mt20">
        <div class="flex-style" style="margin-right:20px">
          <el-button :type="selectIndex == index ?'primary':''" v-for="(item,index) in selectList" :key="index" @click="reset(index)">{{item}}</el-button>
        </div>
        <el-date-picker
            v-model="value4"
            type="daterange"
            range-separator="至"
            clearable
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dataPickerChange"
            start-placeholder="起始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="getOrderStoreStat(),getOrderServiceStat()" style="margin-left:20px">查询</el-button>
          <el-button  @click="reset(0)">重置</el-button>
    </div>

    <div class="flex-style" style="align-items:start;margin-top:40px">
      <div style="width:76%">
        <div class="space-between mt20">
          <span style="font-weight:550">门店数据一览</span>
          <span style="cursor:pointer" @click="getOrderStoreStatExport()">导出数据</span>
        </div>
        <el-table
          :data="tableData"
          border
          @sort-change="doSort"
          style="max-width: 99%;margin-top:20px">
            <el-table-column
              prop="storeName"
              align="center"
              header-align="center"
              label="门店">
            </el-table-column>
            <el-table-column
              prop="totalOrderCount"
              header-align="center"
              align="center"
              sortable="custom"
              label="总订单量">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              sortable="custom"
              prop="completedOrderCount"
              label="已成交订单">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              sortable="custom"
              prop="conversionRate"
              label="转化率(%)">
              <template slot-scope="scope">
                <span>{{(scope.row.conversionRate * 100).toFixed(1)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="totalAmount"
              sortable="custom"
              label="成交金额（元）">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="customerPrice"
              sortable="custom"
              label="客单价（元）">
            </el-table-column>
            
        </el-table>
        <div class="space-between mt20">
          <span style="font-weight:550">回收商数据一览</span>
          <span style="cursor:pointer" @click="getOrderServiceStatExport()">导出数据</span>
        </div>
        <el-table
          :data="dataList"
          border
          @sort-change="doSort2"
          style="max-width: 99%;margin-top:20px">
            <el-table-column
              prop="showServiceProviderName"
              align="center"
              header-align="center"
              label="回收商">
            </el-table-column>
            <el-table-column
              prop="totalOrderCount"
              header-align="center"
              align="center"
              label="推送单量">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="quoteTotalOrderCount"
              label="报价单量">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              sortable="custom"
              prop="completedOrderCount"
              label="已成交订单">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="totalAmount"
              sortable="custom"
              width="150"
              label="成交金额（元）">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="conversionRate"
              sortable="custom"
              label="转化率（%）">
              <template slot-scope="scope">
                <span>{{(scope.row.conversionRate*100).toFixed(1)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="quotationPer"
              sortable="custom"
              label="报价率（%）">
              <template slot-scope="scope">
                <span>{{(scope.row.quotationPer*100).toFixed(1)}}</span>
              </template>
            </el-table-column>
             <el-table-column
              align="center"
              header-align="center"
              prop="averageQuotationAging"
              width="150"
              sortable="custom"
              label="均报时（秒）">
            </el-table-column>
            <el-table-column
              align="center"
              header-align="center"
              prop="customerPrice"
              sortable="custom"
              label="客单价（元）">
            </el-table-column>
            
        </el-table>
      </div>
      <el-card style="flex:1;margin-left:40px;max-height:780px;overflow-y:auto">
        <p style="font-weight:550">门店成交额排名</p>
        <div class="space-between" v-for="(item,index) in rankData" :key="index" style="line-height:48px">
          <div>{{index + 1}} {{item.storeName}}</div>
          <div>{{item.totalAmount}}</div>
        </div>
    </el-card>
    </div>
   
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return{
      rankData:[],
      value4:'',
      selectIndex:0,
      merchantList:[],
      merchantId:"",
      selectList:['今日','本周','本月'],
      endTime: undefined,
      startTime: undefined,
      tableData:[],
      dataList:[],
      statisInfo:null,
      sort:undefined,
      sortFiled:undefined,
      sort2:undefined,
      sortFiled2:undefined,

    }
  },
  created () {
    this.getMerchantList()
  },
  methods:{
    doSort (column) {
      console.log(column)
      this.sortFiled = column.prop
      this.sort = column.order =='ascending'?1:2
      this.getOrderStoreStat()
    },
    doSort2 (column) {
      console.log(column)
      this.sortFiled2 = column.prop
      this.sort2 = column.order =='ascending'?1:2
      this.getOrderServiceStat()
    },
     getMerchantList() {
       this.$api.getMymerchant().then((res)=>{
        console.log(res)
        if(res.code == 200){
          this.merchantList = res.data;
          if(this.merchantList&&this.merchantList.length){
            this.merchantId = this.merchantList[0].id
            if(this.merchantList.length > 1) {
              this.merchantList.unshift({
                id: -1,
                name:'区域合并数据'
              })
              this.merchantId = -1;
            }
            this.getData()
            this.getOrderStoreStat()
            this.getOrderServiceStat()
          }
        }
      })
    },
    getOrderStoreStat () { 
      let json = {
        type:this.startTime?undefined:this.selectIndex + 1,
        startTime:this.startTime,
        endTime:this.endTime,
        merchantId:this.merchantId,
        sort:this.sort,
        sortFiled:this.sortFiled
      }
      this.$api.getOrderStoreStat(json).then((res)=>{
        console.log(res)
        if(res.code == 200){
          this.tableData = res.data.orderStoreDatas;
          this.rankData = res.data.orderStoreTotalAmountDatas;
        }
      })
    },
    getOrderStoreStatExport () {
      let json = {
        type:this.startTime?undefined:this.selectIndex + 1,
        startTime:this.startTime,
        endTime:this.endTime,
        merchantId:this.merchantId,
        sort:this.sort,
        sortFiled:this.sortFiled,
        userId:JSON.parse(localStorage.getItem('userInfo')).data.id
      }
       let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''
       window.open(prefix + `/api/hjx/dataStat/orderStoreStatExport?${qs.stringify(json)}`)
    },
    getOrderServiceStat () {
      let json = {
        type:this.startTime?undefined:this.selectIndex + 1,
        startTime:this.startTime,
        endTime:this.endTime,
        merchantId:this.merchantId,
        sort:this.sort2,
        sortFiled:this.sortFiled2
      }
      
      this.$api.getOrderServiceStat(json).then((res)=>{
        console.log(res)
        if(res.code == 200){
          this.dataList = res.data;
        }
      })
    },
    getOrderServiceStatExport () {
       let json = {
        type:this.startTime?undefined:this.selectIndex + 1,
        startTime:this.startTime,
        endTime:this.endTime,
        merchantId:this.merchantId,
        sort:this.sort2,
        sortFiled:this.sortFiled2
      }
       let prefix = process.env.NODE_ENV === 'development' ? '/api2' : ''
       window.open(prefix + `/api/hjx/dataStat/orderServiceStatExport?${qs.stringify(json)}`)
    },
    getData () {
      this.$api.getIndex({merchantId:this.merchantId}).then((res)=>{
        console.log(res)
        if(res.code == 200){
          this.statisInfo = res.data;
        }
      })
    },
    reset (index) {
      this.startTime = undefined
      this.endTime = undefined
      this.selectIndex = index
      this.value4 = ''
      this.getOrderStoreStat()
      this.getOrderServiceStat()
    },
    dataPickerChange(val) {
        console.log(val,'val--------')
         if(val&&val.length){
          this.startTime = val[0]
          this.endTime = val[1]
        }else{
          this.startTime = undefined
          this.endTime = undefined
        }
      },
  },
}
</script>

<style scoped lang='less'>
  .home-page{

  }
  .space-between{
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      line-height: 26px;
    }
  }
  .flex-style{
    display: flex;
    align-items: center;
  }
  .mt20{
    margin-top: 20px;
  }
  /deep/.el-table__body-wrapper{
    max-height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>